
//#region src/types/value/embed.ts
/**
* oEmbed 1.0 possible types.
*
* @see oEmbed specification: {@link https://oembed.com}
*/
const OEmbedType = {
	Photo: "photo",
	Video: "video",
	Link: "link",
	Rich: "rich"
};

//#endregion
exports.OEmbedType = OEmbedType;
//# sourceMappingURL=embed.cjs.map